import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "mainbody modulewrap"
};
const _hoisted_2 = {
  class: "subwrap"
};
const _hoisted_3 = {
  class: "subconlist2"
};
const _hoisted_4 = {
  class: "itema1"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  key: 0,
  class: "itema2"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  key: 1,
  class: "itema2"
};
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "subconmap"
}, [/*#__PURE__*/_createElementVNode("iframe", {
  width: "1200",
  height: "400",
  frameborder: "0",
  scrolling: "no",
  marginheight: "0",
  marginwidth: "0",
  src: "https://surl.amap.com/nj6o0B3l3I5"
})], -1);
export default {
  __name: 'contact',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const FFdata = reactive({
      alias: 'contact',
      isLoad: false,
      listInfo: [],
      kindInfo: {},
      topTitle: ''
    });
    const getData = () => {
      proxy.$common.fetch({
        'act': 'sei_info',
        'exts': 'alias=' + FFdata.alias,
        msg: ''
      }, res => {
        proxy.$common.each(res.infodata, item => {
          item.imglist = [];
          if (item.imgs) {
            item.imglist = item.imgs.split(',');
          }
        });
        FFdata.listInfo = res.infodata;
        FFdata.kindInfo = res.infodatakind;
        FFdata.isLoad = true;
        FFdata.topTitle = res.infodatakind.title;
      });
      proxy.$store.SET_NAVALIAS(FFdata.alias);
    };
    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _directive_title = _resolveDirective("title");
      return _unref(FFdata).isLoad ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(FFdata).listInfo, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "subconitema",
          key: item.id
        }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
          src: item.cover
        }, null, 8, _hoisted_5)]), item.imgs ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("img", {
          src: item.imgs
        }, null, 8, _hoisted_7)])) : (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", {
          class: "editor2",
          innerHTML: item.content
        }, null, 8, _hoisted_9)]))]);
      }), 128))]), _hoisted_10])])), [[_directive_title, _unref(FFdata).topTitle]]) : _createCommentVNode("", true);
    };
  }
};